export default __webpack_public_path__ + "images/f527edf273b645f458b42431959c8b04.png";